import { useEffect, useState, Dispatch, SetStateAction } from 'react';

// A source the AI cited: a document (often with a url), or a summary of the tickets it searched.
export interface ChatSource {
  name?: string;
  url?: string;
  [key: string]: unknown;
}

export interface ChatMessage {
  sources?: {
    search_documents_tool?: ChatSource[];
    search_messages_tool?: {
      ticket_id: number;
    }[];
  };
  [key: string]: unknown;
}

export const useChatSources = (
  message: ChatMessage | null | undefined,
): [ChatSource[], Dispatch<SetStateAction<ChatSource[]>>] => {
  const [sources, setSources] = useState<ChatSource[]>([]);

  useEffect(() => {
    const allSources: ChatSource[] = [];

    if (!message?.sources) {
      return;
    }

    if (message.sources.search_documents_tool) {
      allSources.push(...message.sources.search_documents_tool);
    }

    if (message.sources.search_messages_tool) {
      const ticketIds = message.sources.search_messages_tool
        .map((source) => {
          return source.ticket_id;
        })
        .filter(Boolean)
        .join(', ');

      ticketIds && allSources.push({ name: `Ticket IDs: ${ticketIds}` });
    }

    setSources(allSources);
  }, [message]);

  return [sources, setSources];
};
